import { buildApiUrl, API_ENDPOINTS } from '@/constants';
import { api } from '@/utils';
import { useQuery } from '@tanstack/react-query';

const fetchUserSettings = async () => {
    const url = buildApiUrl(API_ENDPOINTS.SETTINGS);
    const response = await api.get(url);
    if (!response.data) throw new Error('Error getting user settings');

    return response.data;
};

export const useFetchUserSettings = (isAuthenticated: boolean) => {
    return useQuery({
        queryKey: ['user-settings'],
        queryFn: fetchUserSettings,
        enabled: isAuthenticated,
        staleTime: Infinity,
        retry: 2,
    });
};
